export default {
  notVeBatch: {
    service:
      'ビデオバッチ制作サービスがまだオープンしていません。担当者に連絡して承認を得てください。',
  },
  validateMessage: '数字、文字、アンダースコアのみをサポート',
  form: {
    setting: {
      min: '最小値',
      max: '最大値',
    },
  },
  back: '戻る',
  projectName: 'プロジェクト名',
  editProject: {
    label: '名前の編集',
    form: {
      name: {
        placeholder: 'プロジェクト名を入力してください',
        empty: 'プロジェクト名は空にできません',
      },
    },
  },
  editVersion: {
    label: '名前の編集',
    form: {
      name: {
        placeholder: 'バージョン名を入力してください',
        empty: 'バージョン名は空にできません',
      },
    },
  },
  copyLink: 'コピー',
  copied: 'コピーしました',
  listEmpty: 'データがありません',
  creativeInfo: {
    form: {
      direction: {
        tips: 'プロジェクトの作成後、画面の向きを変更することはできません。プロジェクトをコピーしてから、選択し直して編集することをお勧めします。',
      },
    },
  },
  common: {
    model: {
      cocos: {
        rule: {
          size: 'ファイルサイズが1Mを超えています',
          filenum: 'zipファイルの数が一致しません',
          name: 'ファイル名または拡張子が大文字と小文字で一致していません',
        },
      },
    },
    button: {
      close: '閉じる',
    },
    form: {
      inputTips: '入力してください',
      checkTips: '選択してください',
    },
  },
  productSelector: {
    selectTips: '製品の選択',
    select: '選択',
    handler: 'ライブラリから選択',
  },
  create: {
    name: '新規',
    successful: '新規作成成功',
  },
  hint: 'ヒント',
  fold: '折りたたむ',
  more: 'さらに表示',
  templatel: {
    delete: {
      noadd: 'テンプレートを削除してもよろしいですか',
    },
  },
  noresults: '結果なし',
  download: 'ダウンロード',
  push: 'プッシュ',
  noData: 'データがありません',
  choice: '選択してください',
  search: {
    noresult:
      '申し訳ありませんが、条件に一致する結果が見つかりませんでした。異なる検索条件をお試しください。',
    text: '検索',
  },
  trial: {
    application: 'トライアル申請',
  },
  notsubscribed: {
    service:
      'このサービスは未開通です。ご利用にはサブスクリプションの開通が必要です。',
  },
  cancel: 'キャンセル',
  submit: '送信',
  startupload: 'アップロードを開始',
  startdownload: 'ダウンロードを開始',
  confirm: '確認',
  OK: '決定',
  apply: '申し込む',
  gotit: '了解しました',
  operate: {
    successful: '操作成功',
  },
  delete: {
    successful: '削除成功',
  },
  update: {
    successful: '更新成功',
  },
  add: {
    uccessful: '追加成功',
  },
  storagefull: {
    tips: 'ストレージ容量がいっぱいです。データを削除するか、販売担当に連絡してストレージを拡張してください。',
  },
  copy: {
    successful: 'コピー成功',
  },
  reset: 'リセット',
  custom: 'カスタマイズ',
  plPoint: {
    list: {
      title: 'トラッキングログ',
    },
    point: {
      gs: 'デモ表示',
      fc: '初回インタラクション',
      ge: 'デモ終了',
      is: 'ジャンプ',
      scene: 'シーン{num}表示',
    },
    pointType: {
      base: '基本トラッキングポイント',
      custom: 'カスタムトラッキングポイント',
    },
  },
}
